module.exports = __webpack_public_path__ + "img/04.14294859.jpg";